import { IJobFilter, JobFeedResponse, JobOrderPriority, JobProps } from 'common/types'
import { createQueryMap } from 'common/utils/createQueryMap'
import { searchQueryBuilder } from 'common/utils/searchQueryBuilder'
import { get, post, put } from 'hooks/use-http/useHttp'
import { NewJobPayload } from 'pages/createJob/types'
import { JobOrderCriteria } from 'common/types'

export const getMemberJobs = (page: number, pageSize: number, orderCriteria: JobOrderCriteria) => {
  const url = `/job/active?page=${page}&pageSize=${pageSize}&areaOfExpertise=${encodeURIComponent(orderCriteria.areaOfExpertise)}&industry=${encodeURIComponent(orderCriteria.industry)}&dir=desc&sort=created_at`
  return get<JobFeedResponse>(url, { useApiKey: true })
}

export const getJobsByQuery = (page: number, pageSize: number, filter: IJobFilter, orderPriority?: JobOrderPriority) => {
  const query = searchQueryBuilder(createQueryMap(filter))

  let url = `/job/search?page=${page}&pageSize=${pageSize}&dir=desc&sort=created_at${query}`
  
  if (orderPriority) {
    url = `/job/search?page=${page}&pageSize=${pageSize}&orderPriority={"areaOfExpertise": "${encodeURIComponent(orderPriority.areaOfExpertise)}", "industry": "${encodeURIComponent(orderPriority.industry)}"}&dir=desc&sort=created_at${query}`
  }

  return get<JobFeedResponse>(url, { useApiKey: true })
}

export async function getJobById(id: string) {
  const url = `/job/${id}`
  const options = { useApiKey: true }

  return get<JobProps>(url, options)
}

export const getPartnerJobs = async (
  id: string,
  page: number,
  pageSize: number,
  status: 'active' | 'closed' | 'expired' = 'active'
) => {
  const url = `/job/partner/${id}?page=${page}&pageSize=${pageSize}&dir=desc&sort=created_at&status=${status}`
  const options = {}
  return get<JobFeedResponse>(url, options)
}

export const createJob = async (userId: string, jobPayload: NewJobPayload) => {
  const response = await post(`job/${userId}`, jobPayload)
  return response
}

export const updateJob = async (userId: string, jobId: string, jobPayload: NewJobPayload) => {
  const response = await put(`job/${userId}/${jobId}`, jobPayload)
  return response
}

export const useJobsApi = () => {
  return {
    getJobById,
    getMemberJobs,
    getJobsByQuery,
    getPartnerJobs,
    createJob,
    updateJob
  }
}
